// announcement bar 
(() => {
  const SECTION_SELECTOR = '.shopify-section.shopify-section-group-header-group.announcement-bar-section';
  const MESSAGE_SELECTOR = '.announcement-bar__message > span';

    // SVG separator
  const SEP_SVG =
    `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.08002 13.88L2.48999 0H0L4.63 13.88H7.08002Z" fill="#030202"/>
</svg>`;

  function applySeparators(root) {
    const targets = root.querySelectorAll(MESSAGE_SELECTOR);
    targets.forEach((el) => {
      if (el.dataset.sepified === 'true') return;

      const text = (el.textContent || '').trim();
      if (!text.includes('\\')) return;

      const parts = text.split(/\\+/g).map(s => s.trim()).filter(Boolean);
      const frag  = document.createDocumentFragment();

      parts.forEach((part, i) => {
        if (i) {
          const sep = document.createElement('span');
          sep.className = 'ann-sep';
          sep.setAttribute('aria-hidden', 'true');
          sep.setAttribute('role', 'presentation');
          sep.innerHTML = SEP_SVG;
          frag.appendChild(sep);
        }

        const chunk = document.createElement('span');
        chunk.className = 'ann-part';
        chunk.textContent = part;
        frag.appendChild(chunk);
      });

      el.textContent = '';
      el.appendChild(frag);
      el.dataset.sepified = 'true';
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(applySeparators);
  }

  // Initial run
  initAll();

  // Re-run in Theme Editor when a matching section reloads
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.matches(SECTION_SELECTOR)) applySeparators(e.target);
  });
})();

(() => {
  const mq = window.matchMedia('(max-width: 749.98px)');
  const homes = new WeakMap(); // subtitle -> placeholder

  function wireSection(section) {
    const media = section.querySelector('.product__media-wrapper');
    const subtitle = section.querySelector(
      '.product__info-wrapper .product__text.inline-richtext.subtitle'
    );
    if (!media || !subtitle) return;

    // Create a placeholder so we can put it back on desktop
    if (!homes.has(subtitle)) {
      const ph = document.createComment('subtitle-home');
      subtitle.parentNode.insertBefore(ph, subtitle);
      homes.set(subtitle, ph);
    }

    function applyMobile() {
      if (subtitle.dataset.moved === '1') return;
      media.parentNode.insertBefore(subtitle, media); // place ABOVE gallery
      subtitle.dataset.moved = '1';
    }

    function applyDesktop() {
      if (subtitle.dataset.moved !== '1') return;
      const ph = homes.get(subtitle);
      if (ph && ph.parentNode) {
        ph.parentNode.insertBefore(subtitle, ph.nextSibling); // restore
        subtitle.dataset.moved = '0';
      }
    }

    function react() {
      mq.matches ? applyMobile() : applyDesktop();
    }

    react();
    mq.addEventListener('change', react);
  }

  function initAll(root = document) {
    root.querySelectorAll('.featured-product').forEach(wireSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });

  // Re-run when Shopify dynamically reloads a section
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();



document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".customer-reviews .multicolumn-card").forEach(card => {
        const info = card.querySelector(".multicolumn-card__info");

        // --- 1. Add stars before title
        if (info && !card.querySelector(".review-stars")) {
            const stars = document.createElement("div");
            stars.className = "review-stars";
            stars.innerHTML = `
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.51938 0L11.0494 5.12L16.6894 5.94L12.6094 9.92004L13.5694 15.54L8.51938 12.88L3.47939 15.54L4.43938 9.92004L0.359375 5.94L5.99937 5.12L8.51938 0Z" fill="#7A411B"/>
        </svg>`.repeat(5);
            info.prepend(stars);
        }

        // --- 2. Move image into avatar circle
        const img = card.querySelector(".multicolumn-card__image");
        if (img && !card.querySelector(".review-avatar")) {
            const avatar = document.createElement("div");
            avatar.className = "review-avatar";
            avatar.appendChild(img.cloneNode(true));
            card.appendChild(avatar);
        }
    });

});



document.addEventListener('DOMContentLoaded', () => {
  const scope = document.querySelector('.cb-customer-reviews');
  if(!scope) return;

  scope.querySelectorAll('.multicolumn-card').forEach(card => {
    const info = card.querySelector('.multicolumn-card__info');
    const rte = info?.querySelector('.rte');
    const avatar = card.querySelector('.review-avatar');

    // If verified badge already exists above avatar, skip
    if(card.querySelector('.review-verified')) return;

    // Create verified badge
    const badge = document.createElement('div');
    badge.className = 'review-verified';
    badge.innerHTML = `
      <span class="badge-icon" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.18 5.59C11.18 5.13 10.27 4.79 10.16 4.37C10.04 3.93 10.65 3.19002 10.43 2.80002C10.2 2.41002 9.24999 2.57 8.92999 2.25C8.60999 1.93 8.77001 0.98 8.38 0.75C7.99001 0.53 7.25 1.13999 6.81 1.01999C6.38 0.909989 6.05 0 5.59 0C5.13 0 4.79 0.909989 4.37 1.01999C3.93 1.13999 3.18 0.52 2.8 0.75C2.41 0.98 2.57 1.93 2.25 2.25C1.93 2.57 0.98 2.41002 0.75 2.80002C0.53 3.19002 1.14 3.93 1.02 4.37C0.910004 4.79999 0 5.13 0 5.59C0 6.05 0.910004 6.39 1.02 6.81C1.14 7.25 0.52 8 0.75 8.38C0.98 8.77001 1.93 8.60999 2.25 8.92999C2.57 9.24999 2.41 10.2 2.8 10.43C3.19 10.65 3.93 10.04 4.37 10.16C4.79999 10.27 5.13 11.18 5.59 11.18C6.05 11.18 6.39 10.27 6.81 10.16C7.25 10.04 7.99001 10.66 8.38 10.43C8.77001 10.2 8.60999 9.24999 8.92999 8.92999C9.24999 8.60999 10.2 8.77001 10.43 8.38C10.65 7.99001 10.04 7.25 10.16 6.81C10.27 6.38 11.18 6.05 11.18 5.59ZM4.99001 7.69L3.22 5.92001L3.98 5.16L4.99001 6.17001L7.61 3.55002L8.37 4.31L4.99001 7.69Z" fill="black"/>
        </svg>
      </span>
        <a href="javascript:void(0)" class="verified-review-text" tabindex="-1">Verified review</a>
    `;

    // Insert after rte and before avatar
    if(rte && avatar){
      avatar.before(badge);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const scope = document.querySelector('.clb-customer-reviews');
  if(!scope) return;

  scope.querySelectorAll('.multicolumn-card').forEach(card => {
    const info = card.querySelector('.multicolumn-card__info');
    const rte = info?.querySelector('.rte');
    const avatar = card.querySelector('.review-avatar');

    // If verified badge already exists above avatar, skip
    if(card.querySelector('.review-verified')) return;

    // Create verified badge
    const badge = document.createElement('div');
    badge.className = 'review-verified';
    badge.innerHTML = `
      <span class="badge-icon" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.18 5.59C11.18 5.13 10.27 4.79 10.16 4.37C10.04 3.93 10.65 3.19002 10.43 2.80002C10.2 2.41002 9.24999 2.57 8.92999 2.25C8.60999 1.93 8.77001 0.98 8.38 0.75C7.99001 0.53 7.25 1.13999 6.81 1.01999C6.38 0.909989 6.05 0 5.59 0C5.13 0 4.79 0.909989 4.37 1.01999C3.93 1.13999 3.18 0.52 2.8 0.75C2.41 0.98 2.57 1.93 2.25 2.25C1.93 2.57 0.98 2.41002 0.75 2.80002C0.53 3.19002 1.14 3.93 1.02 4.37C0.910004 4.79999 0 5.13 0 5.59C0 6.05 0.910004 6.39 1.02 6.81C1.14 7.25 0.52 8 0.75 8.38C0.98 8.77001 1.93 8.60999 2.25 8.92999C2.57 9.24999 2.41 10.2 2.8 10.43C3.19 10.65 3.93 10.04 4.37 10.16C4.79999 10.27 5.13 11.18 5.59 11.18C6.05 11.18 6.39 10.27 6.81 10.16C7.25 10.04 7.99001 10.66 8.38 10.43C8.77001 10.2 8.60999 9.24999 8.92999 8.92999C9.24999 8.60999 10.2 8.77001 10.43 8.38C10.65 7.99001 10.04 7.25 10.16 6.81C10.27 6.38 11.18 6.05 11.18 5.59ZM4.99001 7.69L3.22 5.92001L3.98 5.16L4.99001 6.17001L7.61 3.55002L8.37 4.31L4.99001 7.69Z" fill="black"/>
        </svg>
      </span>
        <a href="javascript:void(0)" class="verified-review-text" tabindex="-1">Verified review</a>
    `;

    // Insert after rte and before avatar
    if(rte && avatar){
      avatar.before(badge);
    }
  });
});





// Inside The Scoop: transform list items into tag pills; build overlay on desktop; move bottom CTA up
// (resilient to section reloads)
// Assumes structure: .inside-the-scoop > .multicolumn-card* > .multicolumn-card__image-wrapper + .multicolumn-card__info
// .multicolumn-card__info contains h3, ul (tags), .rte p (desc), .link (a)
// .inside-the-scoop contains .multicolumn__title and a bottom .button

document.addEventListener('DOMContentLoaded', function () {
    const SCOPE = document.querySelector('.inside-the-scoop');
    if (!SCOPE) return;

    const cards = SCOPE.querySelectorAll('.multicolumn-card');

    cards.forEach(card => {
        const imgWrap = card.querySelector('.multicolumn-card__image-wrapper');
        const info = card.querySelector('.multicolumn-card__info');
        if (!imgWrap || !info) return;

        const h3 = info.querySelector('h3');
        const ul = info.querySelector('ul');

        // Find first plain paragraph (no child elements) as description — no :has()
        let desc = null;
        const ps = info.querySelectorAll('.rte p');
        for (const p of ps) {
            if (p.children.length === 0 && p.textContent.trim() !== '') { desc = p; break; }
        }

        const link = info.querySelector('.link');

        // Build tags from <li> into pills (once)
        let tagsWrap = imgWrap.querySelector('.scoop-tags');
        if (!tagsWrap) {
            tagsWrap = document.createElement('div');
            tagsWrap.className = 'scoop-tags';
            imgWrap.appendChild(tagsWrap);
        }
        if (ul && ul.children.length) {
            Array.from(ul.children).forEach(li => {
                const tag = document.createElement('span');
                tag.className = 'scoop-tag';
                tag.textContent = li.textContent.trim();
                tagsWrap.appendChild(tag);
            });
            ul.remove();
        }

        // Ensure title has class
        if (h3 && !h3.classList.contains('scoop-title')) {
            h3.classList.add('scoop-title');
        }
        // Ensure desc has class (so CSS can hide on mobile)
        if (desc && !desc.classList.contains('scoop-desc')) {
            desc.classList.add('scoop-desc');
        }

        // Create one overlay container per card (inside the image wrapper)
        let overlay = imgWrap.querySelector('.scoop-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'scoop-overlay';
            imgWrap.appendChild(overlay);
        }

        const mq = window.matchMedia('(min-width: 990px)');

        function mountOverlay(e) {
            const desktop = e ? e.matches : mq.matches;

            if (desktop) {
                // Desktop: title + tags + desc + link all on image
                if (h3 && !overlay.contains(h3)) overlay.appendChild(h3);
                if (tagsWrap && !overlay.contains(tagsWrap)) overlay.appendChild(tagsWrap);
                if (desc && !overlay.contains(desc)) overlay.appendChild(desc);

                if (link) {
                    let holder = overlay.querySelector('.scoop-link');
                    if (!holder) {
                        holder = document.createElement('div');
                        holder.className = 'scoop-link';
                        overlay.appendChild(holder);
                    }
                    if (link.parentElement !== holder) holder.appendChild(link);
                }
            } else {
                // Mobile/Tablet: title inside image; pills on image; desc hidden; link below image
                if (h3 && !overlay.contains(h3)) overlay.appendChild(h3);     // <- move title into image
                if (tagsWrap && tagsWrap.parentElement !== overlay) overlay.appendChild(tagsWrap);
                // keep desc in overlay (class .scoop-desc is hidden via CSS)
                if (desc && !overlay.contains(desc)) overlay.appendChild(desc);

                // move link back under image
                const existingHolder = overlay.querySelector('.scoop-link');
                if (existingHolder && existingHolder.firstElementChild) {
                    info.appendChild(existingHolder.firstElementChild); // <a>
                    existingHolder.remove();
                }
            }
        }

        mountOverlay();
        mq.addEventListener('change', mountOverlay);
    });

    // Move bottom CTA up next to the heading (desktop clone only)
    const titleWrap = SCOPE.querySelector('.multicolumn__title');
    const bottomCta = SCOPE.querySelector('.center .button');
    if (titleWrap && bottomCta && !titleWrap.querySelector('.scoop-top-cta')) {
        const topCta = bottomCta.cloneNode(true);
        topCta.classList.add('scoop-top-cta');
        titleWrap.appendChild(topCta);
    }
});



// How To: Add step badges (image badge + inline badge before title)
// Assumes structure: .how-to-evening-being > .multicolumn-card* > .multicolumn-card__image-wrapper + .multicolumn-card__info
// .multicolumn-card__info contains h3 (title)
document.addEventListener('DOMContentLoaded', () => {
    const scope = document.querySelector('.how-to-evening-being');
    if (!scope) return;

    const cards = scope.querySelectorAll('.multicolumn-card');
    cards.forEach((card, i) => {
        const step = i + 1;
        const info = card.querySelector('.multicolumn-card__info');
        const h3 = info?.querySelector('h3');
        if (!info || !h3) return;

        // remove old image badge if it ever existed
        card.querySelectorAll('.howto-badge').forEach(n => n.remove());

        // build a single title line: [badge] [title]
        let line = info.querySelector('.howto-titleline');
        if (!line) {
            line = document.createElement('div');
            line.className = 'howto-titleline';
            info.prepend(line);              // <— prepend inside .multicolumn-card__info
        } else {
            line.innerHTML = '';
        }

        const badge = document.createElement('span');
        badge.className = 'howto-badge-inline';
        badge.textContent = step;

        line.appendChild(badge);
        line.appendChild(h3);              // move existing <h3> into the line
    });
});


// Morning Being: Move bottom CTA up next to the heading (desktop clone only)
// Assumes structure: .morning-being-comapare-coffee > .multicolumn__title + .multicolumn-card* + .center .button
// (one button at the bottom center)
document.addEventListener('DOMContentLoaded', () => {
    const S = document.querySelector('.morning-being-comapare-coffee');
    if (!S) return;

    const top = S.querySelector('.multicolumn__title');
    const bottomBtn = S.querySelector('.center .button');
    if (top && bottomBtn && !top.querySelector('.compare-top-cta')) {
        const clone = bottomBtn.cloneNode(true);
        clone.classList.add('compare-top-cta');
        top.appendChild(clone);
    }
});




document.addEventListener("DOMContentLoaded", function () {
    const rtes = document.querySelectorAll(
        ".why-need-upgrade slider-component .multicolumn-card__info .rte"
    );

    // loop through each .rte
    rtes.forEach(function (rte) {
        if (rte) {
            const children = Array.from(rte.children);
            const newBlocks = [];

            for (let i = 0; i < children.length; i++) {
                if (children[i].tagName === "H4") {
                    const block = document.createElement("div");
                    block.classList.add("rte-block");
                    block.appendChild(children[i]); // move H4
                    if (children[i + 1] && children[i + 1].tagName === "P") {
                        block.appendChild(children[i + 1]); // move P
                        i++; // skip next
                    }
                    newBlocks.push(block);
                }
            }

            // replace original content
            rte.innerHTML = "";
            newBlocks.forEach(b => rte.appendChild(b));
        }
    });


});


document.addEventListener("DOMContentLoaded", function () {
  const SELECTOR = ".inside-the-scoop-v2 .multicolumn-card__info .inline-richtext";
  const FULL_TEXT_EXPECTED = "What’s inside? Potent researched- backed ingredeients"; // the exact full string you expect
  const MOBILE_TEXT = "What’s inside?";
  const mq = window.matchMedia("(max-width: 989px)");

  const el = document.querySelector(SELECTOR);
  if (!el) return;

  // Cache the true original once (even if it differs slightly from FULL_TEXT_EXPECTED)
  if (!el.dataset.fullText) {
    el.dataset.fullText = el.textContent.trim();
  }

  function updateText() {
    if (!el) return;

    const isMobile = mq.matches;
    const orig = el.dataset.fullText;

    if (isMobile) {
      // Only shorten if it matches the expected full string or the cached original
      const current = el.textContent.trim();
      if (current === FULL_TEXT_EXPECTED || current === orig) {
        el.textContent = MOBILE_TEXT;
      }
    } else {
      // Restore the original on desktop
      if (el.textContent.trim() !== orig) {
        el.textContent = orig;
      }
    }
  }

  // Run once on load
  updateText();

  // React to media-query changes (more reliable than resize thrash)
  mq.addEventListener?.("change", updateText);

  // Safety net: debounced resize for older browsers
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateText, 150);
  }, { passive: true });
});


document.addEventListener("DOMContentLoaded", function () {
  const SELECTOR = ".inside-the-scoop-split .split-copy-container .inline-richtext";
  const FULL_TEXT_EXPECTED = "What’s inside? Potent researched- backed ingredeients"; // the exact full string you expect
  const MOBILE_TEXT = "What’s inside?";
  const mq = window.matchMedia("(max-width: 989px)");

  const el = document.querySelector(SELECTOR);
  if (!el) return;

  // Cache the true original once (even if it differs slightly from FULL_TEXT_EXPECTED)
  if (!el.dataset.fullText) {
    el.dataset.fullText = el.textContent.trim();
  }

  function updateText() {
    if (!el) return;

    const isMobile = mq.matches;
    const orig = el.dataset.fullText;

    if (isMobile) {
      // Only shorten if it matches the expected full string or the cached original
      const current = el.textContent.trim();
      if (current === FULL_TEXT_EXPECTED || current === orig) {
        el.textContent = MOBILE_TEXT;
      }
    } else {
      // Restore the original on desktop
      if (el.textContent.trim() !== orig) {
        el.textContent = orig;
      }
    }
  }

  // Run once on load
  updateText();

  // React to media-query changes (more reliable than resize thrash)
  mq.addEventListener?.("change", updateText);

  // Safety net: debounced resize for older browsers
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateText, 150);
  }, { passive: true });
});


// Cell being page 

/* === Content Tabs + Accordion: move heading into left column on desktop === */
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.content-tabs-accordion').forEach(section => {
    const heading = section.querySelector('.cta-heading');
    const grid    = section.querySelector('.cta-grid');
    const desktop = section.querySelector('.cta-desktop');
    if (!heading || !grid || !desktop) return;

    // placeholder to restore original position on mobile
    const placeholder = document.createElement('span');
    placeholder.className = 'cta-heading__placeholder';
    heading.after(placeholder);

    function placeForViewport(e){
      const isDesktop = mq.matches; // (min-width: 990px)
      if (isDesktop) {
        // move heading inside the grid, above tabs
        if (heading.parentElement !== grid) {
          grid.insertBefore(heading, grid.firstElementChild); // before <nav.cta-tabs>
          heading.classList.add('cta-heading--in-grid');
        }
      } else {
        // move heading back to original spot (before .cta-desktop)
        if (heading.parentElement === grid) {
          placeholder.before(heading);
          heading.classList.remove('cta-heading--in-grid');
        }
      }
    }

    // initial and on resize
    placeForViewport();
    if (mq.addEventListener) mq.addEventListener('change', placeForViewport);
    else mq.addListener(placeForViewport); // older Safari fallback
  });
});


// Timeline tabs: split pill text into label + number spans
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.timeline-tabs .tt-pill').forEach(function (btn) {
    const txt = btn.textContent.trim();
    // Match: any non-digits, then the trailing digits (works for 7/30/90/180/365)
    const m = txt.match(/^(\D+?)\s+(\d+)$/);
    if (!m) return;
    const label = m[1].trim();
    const num = m[2];

    btn.innerHTML = `
      <span class="tt-pill__label">${label}</span>
      <span class="tt-pill__num">${num}</span>
    `;
  });
});


/**
 * Featured Collection PLUS: star rating injection + layout tweaks
 * - Inject static ★★★★★ if no app rating exists.
 * - Move badges onto the image.
 * - Apply override image src/srcset if present.
 * - Move .card-plus__extras into the bottom .card__information block.
 */
(function () {
  'use strict';

  var STAR_SVG = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M4.88 0L6.39 3.06006L9.76 3.55005L7.32 5.93005L7.9 9.29004L4.88 7.70996L1.86 9.29004L2.44 5.93005L0 3.55005L3.37 3.06006L4.88 0Z" fill="black"/></svg>';

  function ensureRating(card) {
    // Skip if a reviews app rating or a custom ".ratting" is present
    var hasExisting =
      card.querySelector('.rating, .spr-badge, [data-rating], .jdgm-prev-badge, .yotpo-bottomline') ||
      card.querySelector('.ratting');

    // Always target the BOTTOM info block (last .card__information)
    var infos = card.querySelectorAll('.card__content .card__information');
    if (!infos.length) return;
    var info = infos[infos.length - 1];

    // Already placed here?
    if (info.querySelector('.card-plus__rating')) return;

    // If no app rating, create 5 stars and insert before title
    if (!hasExisting) {
      var wrap = document.createElement('div');
      wrap.className = 'card-plus__rating';
      wrap.innerHTML = STAR_SVG + STAR_SVG + STAR_SVG + STAR_SVG + STAR_SVG;
      info.insertBefore(wrap, info.firstChild);
    }
  }

  function applyOverrideImage(card) {
    var src = card.getAttribute('data-override-src');
    if (!src) return;

    var img = card.querySelector('.card__media img');
    if (!img) return;

    // Replace main image only for this card
    img.setAttribute('src', src);

    var srcset = card.getAttribute('data-override-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
  }

  function moveBadgesToImage(card) {
    var badges = card.querySelector('.card-plus__tags');
    if (!badges) return;
    var media = card.querySelector('.card__inner .card__media') || card.querySelector('.card__inner');
    if (!media) return;
    badges.classList.add('card-plus__tags--overlay');
    media.appendChild(badges);
  }

  /**
   * Move .card-plus__extras into the bottom .card__information block
   * inside .card > .card__content.
   */
  function moveExtrasIntoInfo(card) {
    var extras = card.querySelector('.card-plus__extras');
    if (!extras) return;

    // Prefer the bottom info block
    var infos = card.querySelectorAll('.card > .card__content .card__information, .card__content .card__information');
    if (!infos.length) return;

    var info = infos[infos.length - 1];

    // Already in place?
    if (extras.parentElement === info) return;

    info.appendChild(extras);
  }

  function prepare(card) {
    if (card.dataset.rbPlusPlaced === '1') return;
    card.dataset.rbPlusPlaced = '1';
    ensureRating(card);
    moveBadgesToImage(card);
    applyOverrideImage(card);
    moveExtrasIntoInfo(card);
  }

  function init() { document.querySelectorAll('[data-rb-card-plus]').forEach(prepare); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();






// /**
//  * Product Accordion — Single-Open Behavior (Shopify/Dawn)
//  * -------------------------------------------------------
//  * Scope: Only runs on product pages (checks `.product__info-container`).
//  * Target: Only <details> that are direct children of `.product__accordion` blocks.
//  * Behavior: When one accordion opens, remove `open` from its sibling accordions
//  *           under the same parent wrapper—so only one stays open at a time.
//  * Triggers: Uses the native `toggle` event on <details> (fires after state changes).
//  * Notes:
//  *   - No delay required; inside `toggle`, the `open` attribute/state is already updated.
//  *   - Works with multiple accordion groups on the same product page.
//  *   - Unobtrusive, vanilla JS, safe for Dawn-based themes.
//  */

// document.addEventListener('DOMContentLoaded', function () {
//   // guard: only run on product pages with accordions present
//   const productInfo = document.querySelector('.product__info-container');
//   if (!productInfo) return;

//   const allDetails = productInfo.querySelectorAll('.product__accordion > details');
//   if (!allDetails.length) return;

//   allDetails.forEach(function (detailsEl) {
//     detailsEl.addEventListener('toggle', function () {
//       // proceed only when THIS details has just been opened (via attribute check)
//       if (!detailsEl.hasAttribute('open')) return;

//       // find the group parent so we only touch sibling accordions
//       const wrapper = detailsEl.closest('.product__accordion');
//       const groupParent = wrapper && wrapper.parentElement;
//       if (!groupParent) return;

//       // close ONLY siblings: direct children .product__accordion > details under the same parent
//       const siblings = groupParent.querySelectorAll(':scope > .product__accordion > details');
//       siblings.forEach(function (sib) {
//         if (sib !== detailsEl && sib.hasAttribute('open')) {
//           sib.removeAttribute('open');
//         }
//       });
//     });
//   });
// });













// Insta feed slider customization 

// Plain JS: tag footer group if it contains the Insta feed app block
(() => {
  const TARGET_SEL = '.shopify-section-group-footer-group .shopify-app-block #insta-feed';
  const FOOTER_GROUP = '.shopify-section-group-footer-group';
  const CLASS_NAME = 'insta-feed-footer'; // <- the custom class to add

  function apply() {
    const matches = document.querySelectorAll(TARGET_SEL);
    matches.forEach(node => {
      const group = node.closest(FOOTER_GROUP);
      if (group) group.classList.add(CLASS_NAME);
    });
  }

  // Run now
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Optional: catch late-loaded app blocks (Shopify apps often inject later)
//   const mo = new MutationObserver(() => apply());
//   mo.observe(document.documentElement, { childList: true, subtree: true });
})();
















/* Better Being – move .bbp__media for mobile only on this page */
(() => {
  'use strict';

  if (!/^\/pages\/better-being\/?$/.test(location.pathname)) return;

  document.addEventListener('DOMContentLoaded', () => {
    try {
      const root    = document.querySelector('.bbp__default.page-width');
      const content = root?.querySelector('.bbp__content');
      const media   = root?.querySelector('.bbp__media');
      const mq      = window.matchMedia('(max-width: 749px)');
      if (!root || !content || !media || !mq) return;

      // Remember original placement to restore on desktop
      const origParent = media.parentNode;
      const origNext   = media.nextSibling; // may be null

      const toMobile = () => {
        const selectorSlot = content.querySelector('.bbp__selector-slot');
        if (!selectorSlot) {
          // Fallback: just move media to top of content if selector not present
          if (media.parentNode !== content) content.insertBefore(media, content.firstChild);
          return;
        }
        if (media.parentNode !== content || media.nextElementSibling !== selectorSlot) {
          content.insertBefore(media, selectorSlot);
        }
      };

      const toDesktop = () => {
        if (media.parentNode !== origParent) {
          if (origNext) origParent.insertBefore(media, origNext);
          else origParent.appendChild(media);
        }
      };

      const apply = () => (mq.matches ? toMobile() : toDesktop());

      apply();
      // Switch on resize
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply); // Safari fallback
    } catch (_) {
      /* swallow */
    }
  });
})();




/*!
 * accordion-single-open-smooth.js
 * - Single-open behavior + smooth open/close animation for Dawn-style accordions (<details>).
 *
 * Targets:
 *  1) .subscribe-faq-with-image .faqimg__faq .accordion > details
 *  2) .collapsible-content .accordion > details
 *
 * Exposes:
 *   window.AccordionSingleOpenSmooth.init(root?)
 *   window.AccordionSingleOpenSmooth.destroy(root?)
 */
(() => {
    'use strict';

    // Enable CSS hooks
    document.documentElement.classList.add('js-acc-anim');

    const DETAILS_SELECTORS = [
        '.subscribe-faq-with-image .faqimg__faq .accordion > details',
        '.collapsible-content .accordion > details',
    ].join(',');

    // Track wired <details> -> state
    const wired = new WeakMap();

    const prefersReducedMotion = () =>
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getDetailsNodes = (root = document) =>
        Array.from(root.querySelectorAll(DETAILS_SELECTORS));

    function getGroup(detailsEl) {
        // FAQ group
        const faqGroup = detailsEl.closest('.faqimg__faq');
        if (faqGroup) return faqGroup;

        // Collapsible content: keep it scoped to the column (grid__item) if present
        const gridItem = detailsEl.closest('.grid__item');
        if (gridItem) return gridItem;

        // Fallback: the collapsible section wrapper
        const collapsible = detailsEl.closest('.collapsible-content');
        if (collapsible) return collapsible;

        // Last resort: parent
        return detailsEl.parentElement || document;
    }

    function getSiblings(detailsEl) {
        const group = getGroup(detailsEl);
        let nodes = [];

        try {
            nodes = Array.from(group.querySelectorAll(':scope .accordion > details'));
        } catch {
            nodes = Array.from(group.querySelectorAll('.accordion > details'));
        }

        // Ensure siblings are really in the same resolved group
        return nodes.filter(d => getGroup(d) === group);
    }

    function setAria(detailsEl) {
        const summary = detailsEl.querySelector('summary');
        if (!summary) return;
        summary.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
    }

    function ensureInner(detailsEl) {
        const content = detailsEl.querySelector('.accordion__content');
        if (!content) return null;

        // Already wrapped
        let inner = content.querySelector(':scope > .acc-anim__inner');
        if (inner) return inner;

        // Wrap children so we animate height without fighting Dawn padding
        const cs = window.getComputedStyle(content);
        const pt = cs.paddingTop;
        const pr = cs.paddingRight;
        const pb = cs.paddingBottom;
        const pl = cs.paddingLeft;

        inner = document.createElement('div');
        inner.className = 'acc-anim__inner';

        // Move current children into inner
        while (content.firstChild) inner.appendChild(content.firstChild);

        // Move padding from content -> inner (preserves design)
        content.style.padding = '0px';
        inner.style.paddingTop = pt;
        inner.style.paddingRight = pr;
        inner.style.paddingBottom = pb;
        inner.style.paddingLeft = pl;

        content.appendChild(inner);
        return inner;
    }

    function stopInFlight(state) {
        if (!state) return;
        if (state.onEnd && state.inner) {
            state.inner.removeEventListener('transitionend', state.onEnd);
        }
        state.onEnd = null;
    }

    function animateOpen(detailsEl, state) {
        // Close siblings first (smoothly)
        getSiblings(detailsEl).forEach(sib => {
            if (sib !== detailsEl && sib.open) {
                const sibState = wired.get(sib);
                animateClose(sib, sibState);
            }
        });

        // Open now so content exists for measurement
        detailsEl.open = true;
        setAria(detailsEl);

        if (prefersReducedMotion()) return;

        const inner = state.inner;
        if (!inner) return;

        stopInFlight(state);

        inner.style.overflow = 'hidden';
        inner.style.height = '0px';

        // Measure end height
        const endHeight = inner.scrollHeight;

        requestAnimationFrame(() => {
            inner.style.height = endHeight + 'px';
        });

        state.onEnd = (e) => {
            if (e.propertyName !== 'height') return;
            stopInFlight(state);

            // Let it breathe naturally after anim
            inner.style.height = '';
            inner.style.overflow = '';
        };

        inner.addEventListener('transitionend', state.onEnd);
    }

    function animateClose(detailsEl, state) {
        if (!detailsEl.open) return;

        setAria(detailsEl);

        if (prefersReducedMotion()) {
            detailsEl.open = false;
            setAria(detailsEl);
            return;
        }

        const inner = state?.inner;
        if (!inner) {
            detailsEl.open = false;
            setAria(detailsEl);
            return;
        }

        stopInFlight(state);

        inner.style.overflow = 'hidden';

        // Start from current height
        const startHeight = inner.scrollHeight;
        inner.style.height = startHeight + 'px';

        requestAnimationFrame(() => {
            inner.style.height = '0px';
        });

        state.onEnd = (e) => {
            if (e.propertyName !== 'height') return;
            stopInFlight(state);

            // Now actually close the <details>
            detailsEl.open = false;
            setAria(detailsEl);

            // Clean up inline styles
            inner.style.height = '';
            inner.style.overflow = '';
        };

        inner.addEventListener('transitionend', state.onEnd);
    }

    function onSummaryClickFactory(detailsEl, state) {
        return function onSummaryClick(e) {
            // We drive the toggle ourselves for animation
            e.preventDefault();

            if (detailsEl.open) animateClose(detailsEl, state);
            else animateOpen(detailsEl, state);
        };
    }

    function init(root = document) {
        const detailsList = getDetailsNodes(root);
        if (!detailsList.length) return;

        detailsList.forEach(detailsEl => {
            if (wired.has(detailsEl)) return;

            const summary = detailsEl.querySelector('summary');
            if (!summary) return;

            const inner = ensureInner(detailsEl);

            const state = { summary, inner, onClick: null, onEnd: null };
            state.onClick = onSummaryClickFactory(detailsEl, state);

            summary.addEventListener('click', state.onClick);

            // Sync aria on load
            setAria(detailsEl);

            wired.set(detailsEl, state);
        });
    }

    function destroy(root = document) {
        const detailsList = getDetailsNodes(root);
        detailsList.forEach(detailsEl => {
            const state = wired.get(detailsEl);
            if (!state) return;

            stopInFlight(state);
            if (state.summary && state.onClick) {
                state.summary.removeEventListener('click', state.onClick);
            }
            wired.delete(detailsEl);
        });
    }

    // Expose
    window.AccordionSingleOpenSmooth = { init, destroy };

    // Auto-boot + Theme Editor hooks
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => init());
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', e => init(e.target));
    document.addEventListener('shopify:section:unload', e => destroy(e.target));
})();



/**
 * Smooth-scroll: "SUBSCRIBE" buttons → Subscribe section for subscribe page
 *
 * Behaviour:
 * - Listens for clicks on elements matching `.go-to-subscribe-section`.
 * - On click, checks if `.section-ss-subscribe` exists on the current page.
 *   - If not present, it does nothing (fails silently).
 * - If present, scrolls the window to that section with a smooth animation.
 * - Uses the CSS custom property `--header-height` defined on the `<html>` tag
 *   to offset the scroll position, keeping the section title visible below
 *   a sticky header.
 *
 */

(function () {
  'use strict';

  const ROOT = document.documentElement;
  const TARGET_SELECTOR = '.section-ss-subscribe';
  const TRIGGER_SELECTOR = '.go-to-subscribe-section';

  function getHeaderOffset() {
    // Read CSS var --header-height from <html>
    const raw = getComputedStyle(ROOT).getPropertyValue('--header-height') || '0';
    // Expect something like "65px"
    const match = raw.match(/([\d.]+)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function scrollToSubscribeSection(event) {
    event.preventDefault();

    const section = document.querySelector(TARGET_SELECTOR);
    if (!section) {
      // No subscribe section on this page → nothing to do
      return;
    }

    const headerOffset = getHeaderOffset();

    const rect = section.getBoundingClientRect();
    const currentScrollY = window.scrollY || window.pageYOffset || 0;

    const targetY = rect.top + currentScrollY - headerOffset;

    window.scrollTo({
      top: targetY,
      behavior: 'smooth'
    });
  }

  function init() {
    const triggers = document.querySelectorAll(TRIGGER_SELECTOR);
    if (!triggers.length) return;

    triggers.forEach((btn) => {
      btn.addEventListener('click', scrollToSubscribeSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();




/*!
 * contact-form-tweaks.js
 * - Removes placeholders from all .field__input
 * - Adds only the email placeholder (custom text)
 * - Renames labels: Name -> Full name, Comment -> Message
 * - Makes Full name, Email, Message required (adds required + aria-required)
 */
(() => {
  'use strict';

  const EMAIL_PLACEHOLDER =
    "If it’s about an existing order please use the email you used when you ordered";

  function setRequired(input, isRequired) {
    if (!input) return;
    if (isRequired) {
      input.setAttribute('required', 'required');
      input.setAttribute('aria-required', 'true');
    } else {
      input.removeAttribute('required');
      input.removeAttribute('aria-required');
    }
  }

  function updateLabelText(labelEl, text, required) {
    if (!labelEl) return;

    // keep Shopify's required star if present, otherwise just set text
    const star = labelEl.querySelector('span[aria-hidden="true"]');
    labelEl.textContent = text;

    if (required) {
      const s = star || document.createElement('span');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = ' *';
      labelEl.appendChild(s);
    }
  }

  function tweakContactForm(root = document) {
    const form = root.querySelector('form#ContactForm');
    if (!form) return;

    // 1) Remove all placeholders from existing inputs/textarea
    form.querySelectorAll('.field__input').forEach(el => {
      el.removeAttribute('placeholder');
    });

    // 2) Grab fields
    const nameInput = form.querySelector('#ContactForm-name');
    const emailInput = form.querySelector('#ContactForm-email');
    const messageInput = form.querySelector('#ContactForm-body'); // textarea

    // 3) Set ONLY email placeholder
    if (emailInput) emailInput.setAttribute('placeholder', EMAIL_PLACEHOLDER);


    // 5) Update labels (Name -> Full name, Comment -> Message)
    const nameLabel = form.querySelector('label[for="ContactForm-name"]');
    const emailLabel = form.querySelector('label[for="ContactForm-email"]');
    const msgLabel = form.querySelector('label[for="ContactForm-body"]');

    updateLabelText(nameLabel, 'Full name', true);
    updateLabelText(emailLabel, 'Email', true);
    updateLabelText(msgLabel, 'Message', true);

    // 6) Required fields
    setRequired(nameInput, true);
    setRequired(emailInput, true);
    setRequired(messageInput, true);
  }

  // Auto-run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tweakContactForm());
  } else {
    tweakContactForm();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', e => tweakContactForm(e.target));
})();













(() => {
  const HOST_SELECTOR = 'shopify-forms-embed#app-embed';
  const STYLE_KEY = 'shopify-forms-contact';

  // Same CSS values, but selectors are now stable (no added classes)
  const INJECTED_CSS = `
    form{
      gap: 13px!important;
    }

    /* Title */
    section[role="dialog"][aria-modal="true"] h2{
      font-size: 32px!important; font-family:'Everett',sans-serif!important; letter-spacing:0!important;
      color:#000; margin:0 0 17px 0!important; font-weight:400;
    }
    @media (min-width:750px){
      section[role="dialog"][aria-modal="true"] h2{ font-size:45px!important; margin-bottom:41px!important; }
    }

    /* Inputs */
    input[data-testid^="field-"]:not([type="file"]){
      padding: 15px 34px!important;
      border-radius:28px !important;
      border:1px solid #000 !important;
      margin:0 !important;
      box-shadow:none !important;
      letter-spacing:0 !important;
      font-family:'Sohne-Leicht',sans-serif !important;
      font-size:16px !important;
      color:#000 !important;
      outline:none !important;
    }

    textarea[name="custom#message"]{
      margin-top: 2px!important; 
      height: 114px;
      padding:18px 34px!important;
    }

    input[data-testid^="field-"]:not([type="file"])::placeholder,
    textarea[name="custom#message"]::placeholder{
      color:#969696 !important;
      opacity:1 !important;
    }

    /* Labels */
    label[id^="label-"]{
      position:relative !important;
      top:auto !important; left:auto !important;
      transform:none !important;
      margin:0 0 5px 0 !important;
      font-size:19px !important;
      font-family:'Everett',sans-serif !important;
      letter-spacing:0 !important;
      color:#000 !important;
      font-weight:400 !important;
      line-height: 1.5!important;
    }

    #label-phone_number{
      margin-left: -96px!important;
    }

    /* Submit */
    button[data-testid="btn-form-submit"]{
      font-family:'Everett',sans-serif !important;
      font-size:16px !important;
      letter-spacing:0 !important;
      max-height: 50px;
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
      height: 50px;
      border: 1px solid #000!important;
      margin-top: 14px;
    }

    /* Upload button responsive margin */
    #custom\\#upload-label{
      margin-top: 25px;
    }
    @media (max-width: 749px){
      #custom\\#upload-label{
        margin-top: 7px;
      }
    }

    .phone-country-selector{
        margin-bottom: 13px;
    }
  `;

  function ensureInjectedStyle(sr) {
    if (sr.querySelector(`style[data-rbx="${STYLE_KEY}"]`)) return;
    const style = document.createElement('style');
    style.dataset.rbx = STYLE_KEY;
    style.textContent = INJECTED_CSS;
    sr.appendChild(style);
  }

  function applyFieldWrapperLayout(sr) {
    // replicate: .rbx-field{ display:flex; flex-direction:column-reverse; margin-bottom:13px; }
    sr.querySelectorAll('input[data-testid^="field-"]:not([type="file"]), textarea[name="custom#message"]')
      .forEach((el) => {
        const wrap = el.closest('div');
        if (!wrap) return;
        wrap.style.display = 'flex';
        wrap.style.flexDirection = 'column-reverse';
        wrap.style.marginBottom = '13px';
      });
  }

  function applyPhoneRowTweaks(sr) {
    const phoneInput = sr.querySelector('#phone_number');
    if (!phoneInput) return;

    const fieldWrap = phoneInput.closest('div');
    const phoneRow = fieldWrap?.parentElement;
    if (!phoneRow) return;

    if (phoneRow.querySelector('.phone-country-selector')) {
      phoneRow.style.alignItems = 'flex-end';
    }

    const countryBtn = phoneRow.querySelector('.phone-country-selector button');
    if (countryBtn) {
      countryBtn.style.maxHeight = '52px';
      countryBtn.style.height = '52px';
      countryBtn.style.minHeight = '52px';
      countryBtn.style.boxSizing = 'border-box';
    }
  }

  function applyEmailPlaceholder(sr) {
    const emailInput = sr.querySelector('#email');
    if (!emailInput) return;

    emailInput.setAttribute(
      'placeholder',
      "If it’s about an existing order please use the email you used when you ordered"
    );
  }

  function addRequiredStar(label) {
    if (!label) return;
    if (label.querySelector('span[data-rbx-required="1"]')) return;

    const star = document.createElement('span');
    star.setAttribute('data-rbx-required', '1');
    star.textContent = '*';
    star.style.color = '#EC2526';
    star.style.marginLeft = '6px';
    star.style.lineHeight = '1';
    label.appendChild(star);
  }

  function applyRequiredMarks(sr) {
    addRequiredStar(sr.querySelector('#label-first_name'));
    addRequiredStar(sr.querySelector('#label-email'));
    addRequiredStar(sr.querySelector('#label-custom\\#message'));
  }

  function applyAttachFilesTweaks(sr) {
    const uploadBtn = sr.querySelector('#custom\\#upload-label');
    if (!uploadBtn) return;

    // Hide the "Attach Files" label above the button (the <p> sibling)
    const topLabel = uploadBtn.previousElementSibling;
    if (topLabel && topLabel.tagName === 'P') {
      topLabel.style.display = 'none';
    }

    // Button CSS (inline)
    Object.assign(uploadBtn.style, {
      height: '52px',
      maxHeight: '52px',
      padding: '0',
      border: '1px solid #000',
      background: '#000',
      color: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '28px',
      boxSizing: 'border-box',
    });

    // Center text: "Attach Files"
    const btnText = uploadBtn.querySelector('p');
    if (btnText) {
      btnText.textContent = 'Attach Files';
      Object.assign(btnText.style, {
        background: 'transparent',
        color: '#fff',
        fontSize: '16px',
        padding: '0',
        margin: '0',
        lineHeight: '1',
        textTransform: 'uppercase',
      });
    }
  }

  function inject(host) {
    const sr = host.shadowRoot;
    if (!sr) return false;

    // IMPORTANT: style uses stable selectors, so we only need to ensure it's there
    ensureInjectedStyle(sr);

    // Inline/layout tweaks (safe to re-run)
    applyFieldWrapperLayout(sr);
    // applyEmailPlaceholder(sr);
    applyRequiredMarks(sr);
    applyPhoneRowTweaks(sr);
    applyAttachFilesTweaks(sr);

    // Bind submit re-apply ONCE (event-based, not constant watching)
    bindSubmitReapplyOnce(host);

    return true;

  }

  function bindSubmitReapplyOnce(host) {
    const sr = host.shadowRoot;
    if (!sr) return;

    if (sr.__rbx_submit_bound) return;
    sr.__rbx_submit_bound = true;

    const reapplySoon = () => {
      // Shopify re-renders async; hit it a couple times
      setTimeout(() => inject(host), 50);
      setTimeout(() => inject(host), 250);
      setTimeout(() => inject(host), 600);
    };

    sr.addEventListener('submit', reapplySoon, true);

    sr.addEventListener('click', (e) => {
      const btn = e.target?.closest?.('button[data-testid="btn-form-submit"]');
      if (btn) reapplySoon();
    }, true);
  }

  function initForHost(host) {
    const t = setInterval(() => {
      if (!host.isConnected) {
        clearInterval(t);
        return;
      }
      if (host.shadowRoot) {
        clearInterval(t);
        inject(host);
      }
    }, 200);
  }

  function init() {
    const existing = document.querySelector(HOST_SELECTOR);
    if (existing) initForHost(existing);

    // Only watch the main DOM until the embed appears (then disconnect)
    const domObserver = new MutationObserver(() => {
      const host = document.querySelector(HOST_SELECTOR);
      if (!host) return;
      domObserver.disconnect();
      initForHost(host);
    });

    domObserver.observe(document.documentElement, { childList: true, subtree: true });

    // fallback poll if needed
    let tries = 0;
    const poll = setInterval(() => {
      const host = document.querySelector(HOST_SELECTOR);
      if (host) {
        clearInterval(poll);
        domObserver.disconnect();
        initForHost(host);
      }
      if (++tries > 150) clearInterval(poll);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();










/**
 * Home-only Smooth Scroll to Collection Section
 * ------------------------------------------------
 * What it does:
 * - On the homepage only (`/`), clicking any element with `.go-to-collection-section`
 *   smoothly scrolls to `.collection-plus-container`.
 * - Accounts for a sticky/fixed header by subtracting the header height from the scroll target.
 *
 * Selectors:
 * - Trigger button: `.go-to-collection-section`
 * - Target section: `.collection-plus-container`
 *
 * Notes:
 * - Uses event delegation (works even if buttons are injected later).
 * - Header height is detected from common Shopify/Dawn header selectors.
 */

(() => {
  'use strict';

  // ✅ Run only on homepage
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path !== '/') return;

  const BTN_SELECTOR = '.go-to-collection-section';
  const TARGET_SELECTOR = '.collection-plus-container';

  function getHeaderHeight(){
    const header = document.querySelector('header');
    return Math.ceil(header.getBoundingClientRect().height);    
  }

  function scrollToTarget() {
    const target = document.querySelector(TARGET_SELECTOR);
    if (!target) return;

    const y = window.scrollY + target.getBoundingClientRect().top - getHeaderHeight();

    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    scrollToTarget();
  });


})();




/**
 * Footer Social Links: force links in the 3rd footer block to open in a new tab.
 *
 * Targets: .footer .footer__blocks-wrapper .footer-block:nth-child(3)
 * - Adds target="_blank" to all anchor tags inside that block
 * - Adds rel="noopener noreferrer" for security best practice
 *
 * Safe to run multiple times (it just re-applies the same attributes).
 */

(() => {
  const block = document.querySelector(
    '.footer .footer__blocks-wrapper .footer-block:nth-child(3)'
  );
  if (!block) return;

  block.querySelectorAll('a[href]').forEach((a) => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });
})();





/**
 * Better Being — move UL below button + add LI icons + wrap LI text
 * - Takes the first .qq-rte ul, wraps it in a div, and moves it AFTER .qq-button-wrapper
 * - Prepends the provided SVG icon to each li (only once)
 * - Wraps the li content (excluding icon) into <span class="qq-li-text">...</span> (only once)
 */
(() => {
  'use strict';

  const ROOT_SELECTOR = '.better-being-qq-video-split';
  const RTE_SELECTOR = '.qq-rte';
  const BTN_WRAP_SELECTOR = '.qq-button-wrapper';
  const LIST_WRAP_CLASS = 'qq-rte-list-wrap';
  const ICON_CLASS = 'qq-li-icon';
  const TEXT_CLASS = 'qq-li-text';

  const ICON_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
      viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true">
      <path d="M11.875 23.375C18.2263 23.375 23.375 18.2263 23.375 11.875C23.375 5.52368 18.2263 0.375 11.875 0.375C5.52373 0.375 0.375 5.52368 0.375 11.875C0.375 18.2263 5.52373 23.375 11.875 23.375Z" fill="#FFE2C5" stroke="black" stroke-width="0.75" stroke-miterlimit="10"></path>
      <path d="M7.30859 12.3518L10.8782 16.2181L16.4453 7.53625" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `.trim();

  function addIcon(li) {
    if (li.querySelector(`:scope > .${ICON_CLASS}`)) return;

    const icon = document.createElement('span');
    icon.className = ICON_CLASS;
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = ICON_SVG;

    li.prepend(icon);
  }

  function wrapLiText(li) {
    // If already wrapped, do nothing
    if (li.querySelector(`:scope > .${TEXT_CLASS}`)) return;

    const iconEl = li.querySelector(`:scope > .${ICON_CLASS}`);

    // Create wrapper
    const textWrap = document.createElement('span');
    textWrap.className = TEXT_CLASS;

    // Move everything except the icon into the text wrapper
    const nodes = Array.from(li.childNodes);
    nodes.forEach((node) => {
      if (iconEl && node === iconEl) return;
      textWrap.appendChild(node); // moves node
    });

    // Insert wrapper after icon if icon exists, otherwise just append
    if (iconEl && iconEl.parentNode === li) {
      iconEl.insertAdjacentElement('afterend', textWrap);
    } else {
      li.appendChild(textWrap);
    }
  }

  function ensureListBelowButton(root) {
    const rte = root.querySelector(RTE_SELECTOR);
    const btnWrap = root.querySelector(BTN_WRAP_SELECTOR);
    if (!rte || !btnWrap) return;

    // UL may be in rte OR already moved into wrapper
    let ul = rte.querySelector('ul');
    let wrap = root.querySelector(`.${LIST_WRAP_CLASS}`);
    if (!ul && wrap) ul = wrap.querySelector('ul');
    if (!ul) return;

    // Create wrapper if missing
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = LIST_WRAP_CLASS;
    }

    // Move UL into wrapper (if not already)
    if (!wrap.contains(ul)) wrap.appendChild(ul);

    // Place wrapper after button
    if (btnWrap.nextElementSibling !== wrap) {
      btnWrap.insertAdjacentElement('afterend', wrap);
    }

    // Enhance list items
    wrap.querySelectorAll('li').forEach((li) => {
      addIcon(li);
      wrapLiText(li);
    });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(ensureListBelowButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();



/**
 * Customer Reviews → Smooth scroll to Klaviyo reviews with sticky header offset
 * - Triggers:
 *    1) .customer-reviews .button[href="#klaviyo-product-reviews-wrapper"]
 *    2) .customer-reviews a.link[href="#klaviyo-product-reviews-wrapper"]
 * - Target: #klaviyo-product-reviews-wrapper
 */
(() => {
  'use strict';

  const TRIGGERS = [
    '.customer-reviews .button',
    '.customer-reviews a.link',
  ].join(',');

  const TARGET_ID = 'klaviyo-product-reviews-wrapper';
  const TARGET_HASH = `#${TARGET_ID}`;

  const HEADER_SELECTORS = [
    '.header-wrapper',
    'header.header',
    '#shopify-section-header',
    '.shopify-section-group-header-group',
    'header',
  ];

  function getHeaderHeight() {
    for (const sel of HEADER_SELECTORS) {
      const el = document.querySelector(sel);
      if (el && el.offsetHeight) return el.offsetHeight;
    }
    return 0;
  }

  function scrollToTarget() {
    const target = document.getElementById(TARGET_ID) || document.querySelector(TARGET_HASH);
    if (!target) return;

    const headerH = getHeaderHeight();
    const top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerH);

    const prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({ top, behavior: prefersReduced ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const el = e.target.closest(TRIGGERS);
    if (!el) return;

    const href = el.getAttribute('href') || '';
    if (href !== TARGET_HASH) return;

    e.preventDefault();
    scrollToTarget();

    // keep hash in URL without native jump
    if (history && history.replaceState) {
      history.replaceState(null, document.title, TARGET_HASH);
    }
  });
})();






/**
 * Collection+ card: make whole card clickable (desktop-friendly).
 * Skips clicks on the "Go" button.
 */
(() => {
  'use strict';

  const ROOT_SELECTOR = '.collection.collection-plus';
  const CARD_SELECTOR = '.card-wrapper.product-card-wrapper';
  const GO_BTN_SELECTOR = '.card-plus__cta a.button';

  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  // ✅ guard without window global
  if (root.dataset.cardClickInit === '1') return;
  root.dataset.cardClickInit = '1';

  root.addEventListener('click', (e) => {
    const card = e.target.closest(CARD_SELECTOR);
    if (!card || !root.contains(card)) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    // skip if clicking GO or any link/button inside (prevents double nav)
    if (e.target.closest(GO_BTN_SELECTOR)) return;
    if (e.target.closest('a, button')) return;

    const link = card.querySelector('a[href^="/products/"]');
    if (!link) return;

    window.location.href = link.getAttribute('href');
  });
})();



/**
 * Replaces dagger characters in accordion titles with a styled span to
 * enforce the desired dagger font treatment, including content rendered
 * after initial page load.
 */

(() => {
  'use strict';

  const TARGET_SELECTOR = 'h2.accordion__title';
  const DAGGER = '†';

  function wrapDagger(node) {
    // Skip if already processed
    if (node.dataset.daggerWrapped === 'true') return;

    const text = node.textContent || '';
    if (!text.includes(DAGGER)) return;

    // Replace all daggers in the text with a styled span
    const html = text.replaceAll(
      DAGGER,
      `<span class="rbx-dagger" style="font-family:'Sohne-Leicht', sans-serif;">${DAGGER}</span>`
    );

    node.innerHTML = html;
    node.dataset.daggerWrapped = 'true';
  }

  function init() {
    document.querySelectorAll(TARGET_SELECTOR).forEach(wrapDagger);
  }

  const pendingRoots = new Set();
  let processScheduled = false;

  function processPendingRoots() {
    pendingRoots.forEach((root) => {
      if (root.matches(TARGET_SELECTOR)) {
        wrapDagger(root);
      }

      root.querySelectorAll(TARGET_SELECTOR).forEach(wrapDagger);
    });

    pendingRoots.clear();
    processScheduled = false;
  }

  function scheduleRootProcessing(root) {
    pendingRoots.add(root);
    if (processScheduled) return;

    processScheduled = true;
    requestAnimationFrame(processPendingRoots);
  }

  function handleMutations(mutationList) {
    mutationList.forEach((mutation) => {
      mutation.addedNodes.forEach((addedNode) => {
        if (addedNode.nodeType !== Node.ELEMENT_NODE) return;
        scheduleRootProcessing(addedNode);
      });
    });
  }

  // Run once
  init();

  // Also handle late-rendered / re-rendered content
  const mo = new MutationObserver(handleMutations);
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();


/**
 * Injects a clone of the Scoop Facts CTA into the product accordion content.
 *
 * Behavior:
 * - Finds the source CTA from `.inside-the-scoop-base` first, then `.inside-the-scoop-split`.
 * - Appends a wrapped clone into the second `.product__info-wrapper .product__accordion.accordion .accordion__content`.
 * - Keeps injection idempotent via `.scoop-facts-cta`.
 * - Proxies clone clicks to the live source CTA so existing modal/open-details logic is reused.
 * - Retries for late-rendered content (20 attempts, every 250ms) and re-runs on Shopify section events.
 */
(() => {
  'use strict';

  const SOURCE_SELECTORS = [
    // preferred
    '.inside-the-scoop-base .button-wrapper button[data-open-details*="ScoopFull"]',
    '.inside-the-scoop-base .button-wrapper a[data-open-details*="ScoopFull"]',
    // fallback
    '.inside-the-scoop-split .button-wrapper button[data-open-details*="ScoopFull"]',
    '.inside-the-scoop-split .button-wrapper a[data-open-details*="ScoopFull"]',
  ];

  const TARGET_SELECTOR = '.product__info-wrapper .product__accordion.accordion .accordion__content';

  const CLONE_CLASS = 'scoop-facts-cta'; // internal marker (idempotency)
  const WRAP_CLASS = 'scoop-facts-cta-wrap';

  function getSourceButton() {
    for (const sel of SOURCE_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function getTargetContent() {
    const contents = document.querySelectorAll(TARGET_SELECTOR);
    return contents[1] || null; // second accordion content only
  }

  function inject() {
    const targetContent = getTargetContent();
    if (!targetContent) return false;

    // already injected?
    if (targetContent.querySelector(`.${CLONE_CLASS}`)) return true;

    const sourceBtn = getSourceButton();
    if (!sourceBtn) return false;

    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    const clone = sourceBtn.cloneNode(true);
    clone.classList.add(CLONE_CLASS);
    clone.dataset.scoopFactsClone = 'true';

    // Click the *live* source button to reuse existing modal logic
    clone.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const liveSource = getSourceButton();
      if (liveSource) liveSource.click();
    });

    wrap.appendChild(clone);
    targetContent.appendChild(wrap);

    return true;
  }

  function boot() {
    if (inject()) return;

    // Capped retries to handle late-rendered sections
    let tries = 0;
    const maxTries = 20; // 20 * 250ms = 5s max
    const interval = 250;

    const t = window.setInterval(() => {
      tries += 1;
      if (inject() || tries >= maxTries) window.clearInterval(t);
    }, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Theme editor / section re-renders
  const reInject = () => inject();
  document.addEventListener('shopify:section:load', reInject);
  document.addEventListener('shopify:section:reorder', reInject);
  document.addEventListener('shopify:section:select', reInject);
})();






/**
 * Keeps body scrolling locked while any <product-modal> is open.
 * - Adds/removes `product-modal-open` on <body> based on modal state.
 * - Observes `open` only on <product-modal> elements (not the full DOM).
 * - Uses a lightweight global child-list observer only to track modal add/remove.
 */
(() => {
  const BODY_CLASS = "product-modal-open";
  const modalObservers = new WeakMap();

  const syncBodyScrollLock = () => {
    const anyModalOpen = !!document.querySelector("product-modal[open]");
    document.body.classList.toggle(BODY_CLASS, anyModalOpen);
  };

  const getModalsFromNode = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return [];
    const element = /** @type {Element} */ (node);
    const modals = [];
    if (element.matches?.("product-modal")) modals.push(element);
    if (element.querySelectorAll) modals.push(...element.querySelectorAll("product-modal"));
    return modals;
  };

  const observeModal = (modal) => {
    if (modalObservers.has(modal)) return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === "attributes" && m.attributeName === "open") {
          syncBodyScrollLock();
          return;
        }
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ["open"] });
    modalObservers.set(modal, observer);
  };

  const unobserveModal = (modal) => {
    const observer = modalObservers.get(modal);
    if (!observer) return;
    observer.disconnect();
    modalObservers.delete(modal);
  };

  const observeExistingModals = () => {
    document.querySelectorAll("product-modal").forEach(observeModal);
  };

  // Track only modal insertion/removal globally so we can attach targeted observers.
  const structureObserver = new MutationObserver((mutations) => {
    let shouldSync = false;
    for (const m of mutations) {
      if (m.type !== "childList") continue;

      for (const node of m.addedNodes) {
        const addedModals = getModalsFromNode(node);
        if (!addedModals.length) continue;
        for (const modal of addedModals) {
          observeModal(modal);
        }
        shouldSync = true;
      }

      for (const node of m.removedNodes) {
        const removedModals = getModalsFromNode(node);
        if (!removedModals.length) continue;
        for (const modal of removedModals) {
          unobserveModal(modal);
        }
        shouldSync = true;
      }
    }

    if (shouldSync) syncBodyScrollLock();
  });

  structureObserver.observe(document.documentElement, {
    subtree: true,
    childList: true,
  });

  const boot = () => {
    observeExistingModals();
    syncBodyScrollLock();
  };

  // Run once on load (handles initial HTML like <product-modal open>)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();



// (() => {
//   const WIDGET_SELECTOR = ".product__info-container .klaviyo-star-rating-widget";
//   const BUTTON_SELECTOR = ".product__info-container .klaviyo-star-rating-widget .kl_reviews__star_rating_widget";
//   const LABEL_SELECTOR  = ".product__info-container .klaviyo-star-rating-widget .kl_reviews__star_rating_widget__label";

//   function getRatingFromAria(widgetEl) {
//     const btn = widgetEl.querySelector(BUTTON_SELECTOR) || widgetEl;
//     const aria = btn.getAttribute("aria-label") || "";
//     // Matches "4.59 stars, 179 ratings"
//     const m = aria.match(/([\d.]+)\s*stars?/i);
//     return m ? m[1] : null;
//   }

//   function updateOne(widgetEl) {
//     const rating = getRatingFromAria(widgetEl);
//     if (!rating) return;

//     const labelEl = widgetEl.querySelector(LABEL_SELECTOR);
//     if (!labelEl) return;

//     // Optional: always show 2 decimals
//     const formatted = Number(rating).toFixed(2);

//     labelEl.textContent = formatted;
//   }

//   function updateAll() {
//     document.querySelectorAll(WIDGET_SELECTOR).forEach(updateOne);
//   }

//   function updateFromElement(el) {
//     if (!el || el.nodeType !== 1) return;

//     if (el.matches(WIDGET_SELECTOR)) {
//       updateOne(el);
//     }

//     if (el.matches(BUTTON_SELECTOR)) {
//       const widget = el.closest(WIDGET_SELECTOR);
//       if (widget) updateOne(widget);
//     }

//     el.querySelectorAll(WIDGET_SELECTOR).forEach(updateOne);
//   }

//   function startObserver() {
//     const observer = new MutationObserver((mutations) => {
//       for (const mutation of mutations) {
//         if (mutation.type === "childList") {
//           mutation.addedNodes.forEach(updateFromElement);
//           continue;
//         }

//         if (mutation.type === "attributes") {
//           const target = mutation.target;
//           if (!(target instanceof Element)) continue;
//           if (!target.matches(BUTTON_SELECTOR)) continue;

//           const widget = target.closest(WIDGET_SELECTOR);
//           if (widget) updateOne(widget);
//         }
//       }
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//       attributeFilter: ["aria-label"]
//     });
//   }

//   // Run at least once
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", () => {
//       updateAll();
//       startObserver();
//     }, { once: true });
//   } else {
//     updateAll();
//     startObserver();
//   }
// })();


(() => {
  const SCOPE_SELECTOR  = ".product__info-container";
  const PILLS_SELECTOR  = ".product-info-pills";
  const WIDGET_SELECTOR = ".klaviyo-star-rating-widget";
  const BUTTON_SELECTOR = ".kl_reviews__star_rating_widget";
  const LABEL_SELECTOR  = ".kl_reviews__star_rating_widget__label";
  const TOP_ROW_CLASS   = "product-info__top-row";

  function ensureTopRow(scope) {
    if (!scope) return null;

    let row = scope.querySelector(`.${TOP_ROW_CLASS}`);
    if (row) return row;

    row = document.createElement("div");
    row.className = TOP_ROW_CLASS;

    // Insert above the title (so row is at top)
    const title = scope.querySelector(".product__title");
    if (title && title.parentNode) {
      title.parentNode.insertBefore(row, title);
    } else {
      scope.insertBefore(row, scope.firstChild);
    }

    return row;
  }

  function movePillsAndWidget(scope) {
    if (!scope) return;

    const pills = scope.querySelector(PILLS_SELECTOR);
    const widget = scope.querySelector(WIDGET_SELECTOR);
    if (!pills || !widget) return;

    const row = ensureTopRow(scope);
    if (!row) return;

    // Keep ordering: pills left, widget right
    if (pills.parentElement !== row) row.appendChild(pills);
    if (widget.parentElement !== row) row.appendChild(widget);
  }

  function getRatingFromAria(scope) {
    const btn = scope.querySelector(BUTTON_SELECTOR);
    const aria = btn?.getAttribute("aria-label") || "";
    // Matches: "4.59 stars, 179 ratings"
    const m = aria.match(/([\d.]+)\s*stars?/i);
    return m ? m[1] : null;
  }

  function updateRatingLabel(scope) {
    const widget = scope.querySelector(WIDGET_SELECTOR);
    if (!widget) return;

    const rating = getRatingFromAria(scope);
    if (!rating) return;

    const labelEl = widget.querySelector(LABEL_SELECTOR);
    if (!labelEl) return;

    labelEl.textContent = Number(rating).toFixed(2);
  }

  function refreshScope(scope) {
    movePillsAndWidget(scope);
    updateRatingLabel(scope);
  }

  function refreshAll() {
    document.querySelectorAll(SCOPE_SELECTOR).forEach(refreshScope);
  }

  function startObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        // If aria-label changes (rating changes), update label in that scope
        if (m.type === "attributes" && m.attributeName === "aria-label") {
          const el = m.target;
          if (!(el instanceof Element)) continue;

          const scope = el.closest(SCOPE_SELECTOR);
          if (scope) refreshScope(scope);
          continue;
        }

        // If nodes are added (widget renders late), re-run for that scope
        if (m.type === "childList") {
          m.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;

            const scope =
              node.matches(SCOPE_SELECTOR) ? node :
              node.closest(SCOPE_SELECTOR);

            if (scope) refreshScope(scope);

            // Also handle when pills/widget appear inside the added subtree
            node.querySelectorAll?.(SCOPE_SELECTOR).forEach(refreshScope);
          });
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-label"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      refreshAll();
      startObserver();
    }, { once: true });
  } else {
    refreshAll();
    startObserver();
  }
})();



/**
 * Morning Being multicolumn video controller.
 *
 * Scope:
 * - Targets only the `.how-to-make-perfect-morning-being` multicolumn section.
 * - Manages custom play/replay overlays and keeps all videos muted/inline.
 *
 * Behavior:
 * - On desktop, the first card video auto-plays when the section is in view.
 * - After the first video ends, the third card video auto-starts after a short delay.
 * - On mobile, each visible video card plays independently as it scrolls into view.
 *
 * Maintenance notes:
 * - The sequence assumes the first and third `.multicolumn-list__item` entries are video cards.
 * - If the section markup, item order, or video wrapper class names change, update the selectors
 *   and `firstItem` / `thirdItem` logic here.
 * - Styles for the overlay button are injected from JS to keep this behavior self-contained.
 */
(() => {
  const SECTION_SELECTOR = ".how-to-make-perfect-morning-being";
  const ITEM_SELECTOR = ".multicolumn-list__item";
  const VIDEO_SELECTOR = "video.multicolumn-card__video";
  const VIDEO_DESKTOP_WRAPPER_SELECTOR = ".multicolumn-card__video-desktop";
  const VIDEO_MOBILE_WRAPPER_SELECTOR = ".multicolumn-card__video-mobile";
  const REPLAY_BUTTON_SELECTOR = ".multicolumn-video-replay";
  const THIRD_VIDEO_DELAY = 700;
  const VIDEO_OVERLAY_VISIBLE_CLASS = "multicolumn-video-overlay-visible";
  const AUDIO_LOCKED_FLAG = "true";
  const mobileMediaQuery = window.matchMedia("(max-width: 749.98px)");
  const sectionStates = new WeakMap();
  const PLAY_ICON_SVG = `
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.47 3.126c.153-.086.326-.129.501-.126.175.003.345.053.495.144l9.843 6.016c.144.088.263.212.346.359.082.147.126.313.126.482 0 .169-.044.335-.126.482a.974.974 0 0 1-.346.358L7.466 16.855a1.08 1.08 0 0 1-1.495-.861V3.984c0-.175.046-.347.134-.498.088-.151.215-.276.366-.36Z" fill="currentColor"></path>
    </svg>
  `;

  function injectStyles() {
    if (document.getElementById("multicolumn-video-sequence-styles")) return;

    const style = document.createElement("style");
    style.id = "multicolumn-video-sequence-styles";
    style.textContent = `
      ${SECTION_SELECTOR} .multicolumn-card__video-desktop,
      ${SECTION_SELECTOR} .multicolumn-card__video-mobile {
        position: relative;
        overflow: hidden;
      }

      ${SECTION_SELECTOR} ${VIDEO_SELECTOR}::-webkit-media-controls {
        display: none !important;
      }

      ${SECTION_SELECTOR} ${VIDEO_SELECTOR} {
        cursor: pointer;
      }

      ${SECTION_SELECTOR} .multicolumn-card__video-desktop::after,
      ${SECTION_SELECTOR} .multicolumn-card__video-mobile::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.28));
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease;
        z-index: 0;
      }

      ${SECTION_SELECTOR} .multicolumn-card__video-desktop.${VIDEO_OVERLAY_VISIBLE_CLASS}::after,
      ${SECTION_SELECTOR} .multicolumn-card__video-mobile.${VIDEO_OVERLAY_VISIBLE_CLASS}::after {
        opacity: 1;
      }

      ${SECTION_SELECTOR} .multicolumn-video-replay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 4.5rem;
        height: 4.5rem;
        border: 0;
        border-radius: 50%;
        background: #fff;
        color: #000;
        cursor: pointer;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease, transform 0.2s ease, background 0.2s ease;
        z-index: 3;
        box-shadow: 0 0.75rem 2rem rgba(0, 0, 0, 0.22);
        backdrop-filter: blur(6px);
      }

      ${SECTION_SELECTOR} .multicolumn-video-replay.is-visible {
        opacity: 1;
        pointer-events: auto;
        transform: translate(-50%, -50%) scale(1);
      }

      ${SECTION_SELECTOR} .multicolumn-video-replay:hover {
        background: #fff;
      }

      ${SECTION_SELECTOR} .multicolumn-video-replay svg {
        width: 1.5rem;
        height: 1.5rem;
        display: block;
        margin-left: 0.14rem;
        color: #000;
      }

      @media screen and (max-width: 749px) {
        ${SECTION_SELECTOR} .multicolumn-video-replay {
          width: 4rem;
          height: 4rem;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden";
  }

  function getVideoContainer(video) {
    return (
      video.closest(VIDEO_DESKTOP_WRAPPER_SELECTOR) ||
      video.closest(VIDEO_MOBILE_WRAPPER_SELECTOR) ||
      video.parentElement
    );
  }

  function getReplayButton(video) {
    const container = getVideoContainer(video);
    if (!container) return null;

    let button = container.querySelector(REPLAY_BUTTON_SELECTOR);
    if (button) return button;

    button = document.createElement("button");
    button.type = "button";
    button.className = "multicolumn-video-replay";
    button.innerHTML = PLAY_ICON_SVG;
    button.addEventListener("click", () => {
      button.classList.remove("is-visible");
      if (button.dataset.action === "replay") {
        video.currentTime = 0;
      }
      playVideo(video);
    });

    container.appendChild(button);
    return button;
  }

  function showOverlayButton(video, mode = "play") {
    const button = getReplayButton(video);
    const container = getVideoContainer(video);
    if (!button || !container) return;

    const isReplay = mode === "replay";
    button.dataset.action = isReplay ? "replay" : "play";
    button.setAttribute("aria-label", isReplay ? "Replay video" : "Play video");
    container.classList.add(VIDEO_OVERLAY_VISIBLE_CLASS);
    button.classList.add("is-visible");
  }

  function hideOverlayButton(video) {
    const button = getReplayButton(video);
    const container = getVideoContainer(video);
    container?.classList.remove(VIDEO_OVERLAY_VISIBLE_CLASS);
    button?.classList.remove("is-visible");
  }

  function pauseOtherVideos(section, activeVideo) {
    section.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
      if (video === activeVideo) return;
      video.pause();
      if (!video.ended) {
        showOverlayButton(video, "play");
      }
    });
  }

  function pauseAllVideos(section) {
    section.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
      video.pause();
    });
  }

  function applyVideoPlaybackAttributes(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.playsInline = true;
  }

  function prepareVideo(video) {
    if (!video) return;

    video.controls = false;
    video.removeAttribute("controls");
    applyVideoPlaybackAttributes(video);
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    if (video.dataset.audioLocked === AUDIO_LOCKED_FLAG) return;

    video.addEventListener("volumechange", () => {
      if (video.muted && video.volume === 0) return;

      applyVideoPlaybackAttributes(video);
    });

    video.dataset.audioLocked = AUDIO_LOCKED_FLAG;
  }

  function playVideo(video) {
    if (!video) return;

    prepareVideo(video);
    hideOverlayButton(video);
    applyVideoPlaybackAttributes(video);

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  }

  function clearThirdVideoTimer(state) {
    if (!state?.thirdVideoTimer) return;

    window.clearTimeout(state.thirdVideoTimer);
    state.thirdVideoTimer = null;
  }

  function getActiveVideo(item) {
    if (!item) return null;

    const videos = item.querySelectorAll(VIDEO_SELECTOR);
    if (!videos.length) return null;
    if (videos.length === 1) return videos[0];

    for (const video of videos) {
      const container = getVideoContainer(video);
      if (isVisible(container)) return video;
    }

    return videos[0];
  }

  function wireVideo(video, section, state) {
    if (!video || video.dataset.sequenceWired === "true") return;

    prepareVideo(video);

    const button = getReplayButton(video);

    video.addEventListener("play", () => {
      hideOverlayButton(video);
      pauseOtherVideos(section, video);
      if (!mobileMediaQuery.matches) {
        state.currentDesktopVideo = video;
      }
    });

    video.addEventListener("ended", () => {
      showOverlayButton(video, "replay");

      if (!mobileMediaQuery.matches) {
        state.currentDesktopVideo = null;
      }

      if (video !== state.firstVideo || state.thirdVideoStarted) return;

      state.waitingForThirdVideo = true;
      maybeStartThirdVideo(section, state);
    });

    if (button) {
      video.addEventListener("pause", () => {
        if (video.ended) return;
        showOverlayButton(video, "play");
      });
    }

    video.addEventListener("click", () => {
      if (video.ended) {
        video.currentTime = 0;
        playVideo(video);
        return;
      }

      if (video.paused) {
        playVideo(video);
        return;
      }

      video.pause();
    });

    video.dataset.sequenceWired = "true";
  }

  function maybeStartThirdVideo(section, state) {
    if (
      !state ||
      !state.waitingForThirdVideo ||
      state.thirdVideoStarted ||
      mobileMediaQuery.matches ||
      !state.desktopInView
    ) {
      return;
    }

    clearThirdVideoTimer(state);

    state.thirdVideoTimer = window.setTimeout(() => {
      state.thirdVideoTimer = null;

      if (mobileMediaQuery.matches || !state.desktopInView) return;

      const thirdVideo = getActiveVideo(state.thirdItem);
      if (!thirdVideo) return;

      state.thirdVideo = thirdVideo;
      state.thirdVideoStarted = true;
      state.waitingForThirdVideo = false;
      wireVideo(thirdVideo, section, state);
      playVideo(thirdVideo);
    }, THIRD_VIDEO_DELAY);
  }

  function resumeDesktopPlayback(section, state) {
    if (!state || mobileMediaQuery.matches || !state.desktopInView) return;

    if (!state.started) {
      startSequence(section);
      return;
    }

    if (state.waitingForThirdVideo && !state.thirdVideoStarted) {
      maybeStartThirdVideo(section, state);
      return;
    }

    const activeVideo =
      (state.thirdVideoStarted && state.thirdVideo && !state.thirdVideo.ended && state.thirdVideo) ||
      (!state.firstVideo?.ended && state.firstVideo) ||
      null;

    if (activeVideo) {
      playVideo(activeVideo);
    }
  }

  function startSequence(section) {
    const state = sectionStates.get(section);
    if (!state || state.started || mobileMediaQuery.matches) return;

    const firstVideo = getActiveVideo(state.firstItem);
    if (!firstVideo) return;

    state.started = true;
    state.firstVideo = firstVideo;
    state.currentDesktopVideo = firstVideo;

    wireVideo(firstVideo, section, state);

    const thirdVideo = getActiveVideo(state.thirdItem);
    if (thirdVideo) {
      wireVideo(thirdVideo, section, state);
      showOverlayButton(thirdVideo, "play");
    }

    playVideo(firstVideo);
  }

  function setupDesktopObserver(section, state) {
    if (state.desktopObserver || !state.firstItem || !state.thirdItem) return;

    if (!("IntersectionObserver" in window)) {
      state.desktopInView = true;
      startSequence(section);
      return;
    }

    state.desktopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (mobileMediaQuery.matches) return;

          const isInView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          state.desktopInView = isInView;

          if (!isInView) {
            clearThirdVideoTimer(state);
            pauseAllVideos(section);
            return;
          }

          resumeDesktopPlayback(section, state);
        });
      },
      {
        threshold: [0, 0.35, 0.6]
      }
    );

    state.desktopObserver.observe(section);
  }

  function setupMobileObserver(section, state) {
    if (state.mobileObserver || !state.videoItems.length) return;

    if (!("IntersectionObserver" in window)) {
      const visibleVideo = getActiveVideo(state.videoItems[0]);
      if (visibleVideo) playVideo(visibleVideo);
      return;
    }

    state.mobileObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const item = entry.target;
          const video = getActiveVideo(item);
          if (!video) return;

          wireVideo(video, section, state);

          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            pauseOtherVideos(section, video);
            playVideo(video);
            return;
          }

          video.pause();
        });
      },
      {
        threshold: [0, 0.6, 1]
      }
    );

    state.videoItems.forEach((item) => {
      state.mobileObserver.observe(item);
    });
  }

  function teardownDesktopObserver(state) {
    state.desktopObserver?.disconnect();
    state.desktopObserver = null;
  }

  function teardownMobileObserver(state) {
    state.mobileObserver?.disconnect();
    state.mobileObserver = null;
  }

  function resetMobileModeState(state) {
    state.desktopInView = false;
    state.started = false;
    state.thirdVideoStarted = false;
    state.waitingForThirdVideo = false;
    state.currentDesktopVideo = null;
    state.firstVideo = null;
    state.thirdVideo = null;
    clearThirdVideoTimer(state);
  }

  function applyMode(section) {
    const state = sectionStates.get(section);
    if (!state) return;

    pauseAllVideos(section);

    if (mobileMediaQuery.matches) {
      teardownDesktopObserver(state);
      resetMobileModeState(state);
      setupMobileObserver(section, state);
      return;
    }

    teardownMobileObserver(state);
    setupDesktopObserver(section, state);
  }

  function initSection(section) {
    if (!section || section.dataset.videoSequenceReady === "true") return;

    const items = section.querySelectorAll(ITEM_SELECTOR);
    const videoItems = Array.from(items).filter((item) => item.querySelector("video"));
    if (!videoItems.length) return;

    const firstItem = items[0];
    const thirdItem = items[2];

    section.dataset.videoSequenceReady = "true";
    const state = {
      started: false,
      thirdVideoStarted: false,
      firstItem: firstItem?.querySelector("video") ? firstItem : null,
      thirdItem: thirdItem?.querySelector("video") ? thirdItem : null,
      videoItems,
      firstVideo: null,
      thirdVideo: null,
      currentDesktopVideo: null,
      waitingForThirdVideo: false,
      thirdVideoTimer: null,
      desktopInView: false,
      desktopObserver: null,
      mobileObserver: null
    };

    sectionStates.set(section, state);

    videoItems.forEach((item) => {
      item.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
        wireVideo(video, section, state);
      });
    });

    applyMode(section);
  }

  function getTargetSections(root = document) {
    if (!root?.querySelectorAll) return [];
    if (root.matches?.(SECTION_SELECTOR)) return [root];
    return Array.from(root.querySelectorAll(SECTION_SELECTOR));
  }

  function initAll(root = document) {
    injectStyles();
    getTargetSections(root).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  mobileMediaQuery.addEventListener("change", () => {
    getTargetSections().forEach(applyMode);
  });
})();


/**
 * Morning Being step-list formatter (how-to-make-perfect-morning-being).
 *
 * Converts colon-delimited list items in the second and fourth multicolumn cards from plain text
 * into separate title/description spans so CSS can style them independently.
 *
 * Expected source format:
 * `Title: description text`
 *
 * Maintenance notes:
 * - This is position-dependent and only targets card 2 and card 4 in the same section.
 * - If content moves to different cards or the text stops using the `Title: description` pattern,
 *   update `LIST_SELECTORS` and the parsing logic below.
 */
(() => {
  const SECTION_SELECTOR = ".how-to-make-perfect-morning-being";
  const LIST_SELECTORS = [
    `${SECTION_SELECTOR} .multicolumn-list__item:nth-child(2) .rte ol li`,
    `${SECTION_SELECTOR} .multicolumn-list__item:nth-child(4) .rte ol li`,
  ].join(",");
  const STEP_ENHANCED_FLAG = "true";
  const STEP_DELIMITER = ":";

  function hasTargetSection(root = document) {
    return Boolean(root.querySelector?.(SECTION_SELECTOR));
  }

  function splitStepContent(text) {
    const delimiterIndex = text.indexOf(STEP_DELIMITER);
    if (delimiterIndex === -1) return null;

    return {
      title: text.slice(0, delimiterIndex).trim(),
      desc: text.slice(delimiterIndex + 1).trim(),
    };
  }

  function createStepPart(className, text) {
    const element = document.createElement("span");
    element.className = className;
    element.textContent = text;
    return element;
  }

  function buildStepMarkup(title, desc) {
    const wrapper = document.createElement("span");
    wrapper.className = "step-text";
    wrapper.appendChild(createStepPart("step-title", title));
    wrapper.appendChild(createStepPart("step-desc", desc));
    return wrapper;
  }

  function enhanceSteps(root = document) {
    if (!hasTargetSection(root)) return;

    root.querySelectorAll(LIST_SELECTORS).forEach((li) => {
      if (li.dataset.stepEnhanced === STEP_ENHANCED_FLAG) return;

      const stepContent = splitStepContent(li.textContent.trim());
      if (!stepContent) return;

      // clear + rebuild safely
      li.textContent = "";
      li.appendChild(buildStepMarkup(stepContent.title, stepContent.desc));
      li.dataset.stepEnhanced = STEP_ENHANCED_FLAG;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => enhanceSteps(), { once: true });
  } else {
    enhanceSteps();
  }

  // Shopify editor / dynamic section reload
  document.addEventListener("shopify:section:load", (e) => enhanceSteps(e.target));
})();

// cart page: free gift lines (Cartbot, $0 and not a subscription) shown as plain text, no product link
(() => {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;

  const unlinkRow = (row) => {
    row.querySelectorAll('a.cart-item__link').forEach((a) => a.remove());
    row.querySelectorAll('a.cart-item__name').forEach((a) => {
      const span = document.createElement('span');
      span.className = a.className;
      span.textContent = a.textContent;
      a.replaceWith(span);
    });
  };

  const unlinkGifts = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        cart.items.forEach((item, i) => {
          if (item.final_price !== 0 || item.selling_plan_allocation) return;
          const row = document.getElementById(`CartItem-${i + 1}`);
          if (row) unlinkRow(row);
        });
      })
      .catch(() => {});
  };

  unlinkGifts();

  // Dawn re-renders the line items after quantity changes
  let timer;
  new MutationObserver(() => {
    if (!cartItems.querySelector('a.cart-item__name')) return;
    clearTimeout(timer);
    timer = setTimeout(unlinkGifts, 150);
  }).observe(cartItems, { childList: true, subtree: true });
})();

// one-time-only products (Morning Being clearance): strip any Subscribe & Save selling plan
// from /cart/add requests, whichever widget or upsell they come from. Seal plan stays attached
// to the product; the product page UI (seal-subscription-widget-enhancer.js) hides it too.
window.oneTimeOnlyHandles = ['morning-being'];
(() => {
  if (typeof window.fetch !== 'function') return;

  let variantIdsPromise;
  const getVariantIds = () => {
    variantIdsPromise = variantIdsPromise || Promise.all(
      window.oneTimeOnlyHandles.map((handle) =>
        originalFetch(`/products/${handle}.js`)
          .then((res) => (res.ok ? res.json() : null))
          .then((p) => (p ? p.variants.map((v) => String(v.id)) : []))
          .catch(() => [])
      )
    ).then((lists) => new Set(lists.flat()));
    return variantIdsPromise;
  };

  const isCartAdd = (input) => {
    try {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input && input.url;
      return /\/cart\/add(\.js)?$/.test(new URL(url, location.origin).pathname);
    } catch (e) {
      return false;
    }
  };

  // Returns the body with selling plans removed from one-time-only variants (same type as given).
  const stripPlans = async (body) => {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      if (!body.get('selling_plan')) return body;
      const ids = await getVariantIds();
      if (ids.has(String(body.get('id')))) body.delete('selling_plan');
      return body;
    }

    if (typeof body === 'string' && body.includes('selling_plan')) {
      let data;
      try {
        data = JSON.parse(body);
      } catch (e) {
        const params = new URLSearchParams(body);
        return (await stripPlans(params)).toString();
      }
      const ids = await getVariantIds();
      const items = Array.isArray(data.items) ? data.items : [data];
      items.forEach((item) => {
        if (item && item.selling_plan && ids.has(String(item.id))) delete item.selling_plan;
      });
      return JSON.stringify(data);
    }

    return body;
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    if (init && init.body && isCartAdd(input)) {
      init = { ...init, body: await stripPlans(init.body) };
    }
    return originalFetch(input, init);
  };
})();
